import React, { useEffect, useState, useContext } from 'react';
import { Typography, makeStyles } from '@material-ui/core';
import { useLocation, Link } from 'react-router-dom';
import $ from 'jquery';
import { useCustomPortalSections } from 'hooks';
import { useIntl } from 'react-intl';
import { setCurrentSection } from 'state/slices/publicPersonalPortal';
import {
  PORTAL_SECTIONS,
  TABS_KEYS,
  COLOR,
  PORTAL_CUSTOM_SECTIONS,
  isDev,
  BROKER_PORTAL_SUBSCRIPTION,
  ENG,
} from 'config/constants';
import { LanguageContext } from 'contexts';
import { useDispatch } from 'react-redux';
import { Broker } from 'models';

const useStyles = makeStyles({
  headerContent: {
    display: 'flex',
    height: '100%',
    minHeight: 100,
    flexDirection: 'row',
    width: '100%',
  },
  mobileSocialMediaContent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  headerRight: {
    display: 'flex',
    position: 'absolute',
    flexDirection: 'column',
    right: 0,
    justifyContent: 'flex-end',
  },
  logoContent: {
    marginLeft: 30,
    alignSelf: 'center',
    alignItems: 'center',
    '@media (max-width: 800px)': {
      marginLeft: 15,
    },
  },
  logo: {
    width: 'auto',
    height: 70,
    objectFit: 'contain',
    '@media (max-width: 800px)': {
      height: 35,
    },
  },
  socialMediaContent: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'row',
    alignItems: 'center',
    '@media (max-width: 600px)': {
      justifyContent: 'center',
    },
  },
  ctaButtonText: {
    fontSize: 16,
    textTransform: 'uppercase',
    '@media (max-width: 800px)': {
      fontSize: 14,
    },
  },
  whiteMenu: {
    fontSize: 16,
    textTransform: 'none',
    color: COLOR.WHITE,
    height: 42,
    '@media (max-width: 800px)': {
      height: 33,
      fontSize: 14,
    },
  },
  darkMenu: {
    fontSize: 16,
    textTransform: 'none',
    color: COLOR.BLACK,
    height: 42,
    '@media (max-width: 800px)': {
      height: 33,
      fontSize: 14,
    },
  },
  hideContent: {
    display: 'none',
  },
  headerRightContent: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'row',
    alignItems: 'center',
  },
  selectedButtonText: {
    fontSize: 16,
    textTransform: 'uppercase',
    '@media (max-width: 800px)': {
      fontSize: 14,
      color: COLOR.WHITE,
    },
  },
  link: {
    textDecoration: 'none',
    marginRight: 15,
    marginLeft: 15,
    cursor: 'pointer !important',
  },
  sectionTabsRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  drawer: {
    bottom: 0,
    paddingTop: 30,
    display: 'none',
    width: 350,
    '@media (max-width: 767px)': {
      display: 'flex',
      justifyContent: 'center',
    },
  },
  menuItemsContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    '& a': {
      color: 'white',
      fontSize: 20,
      padding: 10,
      textDecoration: 'none',
    },
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
  },
  gridItem: {
    height: 30,
    cursor: 'pointer',
  },
  gridLink: {
    height: 20,
    textDecoration: 'none',
    cursor: 'pointer',
  },
});
interface Props {
  portal_infos: any;
  sections?: any;
  favorite_listings: any;
  is_white_text?: boolean;
  showMenu?: boolean;
  setShowMenu?: (any) => void;
  is_mobile?: boolean;
  is_grid_view?: boolean;
  broker: Broker;
}

function PageLinks(props: Props) {
  const {
    portal_infos,
    sections,
    favorite_listings,
    is_white_text,
    showMenu,
    setShowMenu,
    is_mobile,
    is_grid_view,
    broker,
  } = props;
  const styles = useStyles();
  const intl = useIntl();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { language } = useContext(LanguageContext);
  const isEn = language === ENG;
  const defaultSections = [];
  const portfolioSection = {
    key: PORTAL_SECTIONS.PROPERTY.key,
    section: { key: PORTAL_SECTIONS.PROPERTY.key },
  };

  let defaultPath = pathname.split('/')[1];
  const foundSection = Object.keys(PORTAL_CUSTOM_SECTIONS).find((key) => {
    return (
      PORTAL_CUSTOM_SECTIONS[key].key === defaultPath ||
      PORTAL_CUSTOM_SECTIONS[key].key_fr === defaultPath
    );
  });
  if (foundSection) {
    defaultPath = PORTAL_CUSTOM_SECTIONS[foundSection].key;
  }
  if (defaultPath === PORTAL_SECTIONS.PROPERTY.key_fr) {
    defaultPath = PORTAL_SECTIONS.PROPERTY.key;
  }
  const secondary_color = portal_infos?.template_style?.secondary_color || COLOR.LIGHT_BLUE;
  let combinedSections = defaultSections;

  if (
    favorite_listings &&
    favorite_listings.length > 0 &&
    broker?.portalWebsite === BROKER_PORTAL_SUBSCRIPTION.WITH_LISTINGS
  ) {
    combinedSections.push(portfolioSection);
  }

  const { currentSection } = useCustomPortalSections();

  const [sortedSections, setSortedSections] = useState([]);
  const fmtContact = intl.formatMessage({ id: 'portal.contact' });
  const fmtAbout = intl.formatMessage({ id: 'portal.about' });
  const fmtSellers = intl.formatMessage({ id: 'portal.sellers' });
  const fmtBuyers = intl.formatMessage({ id: 'portal.buyers' });
  const fmtTestimonials = intl.formatMessage({ id: 'portal.testimonials' });
  const fmtHome = intl.formatMessage({ id: 'portal.home' });
  const fmtPorfolio = intl.formatMessage({ id: 'portal.properties' });

  useEffect(() => {
    if (isDev() && defaultPath === 'dev-broker-portal') {
      dispatch(setCurrentSection('home'));
    }
    if (defaultPath === portal_infos.domain_name) {
      dispatch(setCurrentSection('home'));
    }
    if (defaultPath) {
      dispatch(setCurrentSection(defaultPath));
    }
    const tabKeys = broker.isPremium || broker?.nonMemberPortalWebsite ? TABS_KEYS : [];
    const sorted_sections = sections
      .filter((sec) => {
        return tabKeys.includes(sec.section.key);
      })
      .filter((sec) => {
        return sec.section.is_visible;
      })
      .sort((a, b) => {
        return tabKeys.indexOf(a.section.key) - TABS_KEYS.indexOf(b.section.key);
      });
    combinedSections = combinedSections.concat(sorted_sections);
    setSortedSections(combinedSections);
  }, [defaultPath]);

  const getSectionTitle = (key: string) => {
    switch (key) {
      case PORTAL_CUSTOM_SECTIONS.ABOUT.key:
        return fmtAbout;
      case PORTAL_CUSTOM_SECTIONS.TESTIMONIAL.key:
        return fmtTestimonials;
      case PORTAL_CUSTOM_SECTIONS.BUYERS.key:
        return fmtBuyers;
      case PORTAL_CUSTOM_SECTIONS.SELLERS.key:
        return fmtSellers;
      case PORTAL_SECTIONS.PROPERTY.key:
        return fmtPorfolio;
      case 'home':
        return fmtHome;
      default:
        return '';
    }
  };

  const getTabLink = (key: string) => {
    if (key === 'home') {
      if (isDev()) {
        return `/dev-broker-portal?domain_name=${portal_infos.domain_name}`;
      }
      return `https://${portal_infos.domain_name}`;
    }
    let url = `/${key}`;
    if (!isEn) {
      const section = PORTAL_CUSTOM_SECTIONS[key.toUpperCase()];
      if (section) {
        url = `/${section.key_fr}`;
      } else if (key === PORTAL_SECTIONS.PROPERTY.key) {
        url = `/${PORTAL_SECTIONS.PROPERTY.key_fr}`;
      } else {
        url = `/${key}`;
      }
    }
    if (isDev()) {
      return `${url}?domain_name=${portal_infos.domain_name}`;
    }
    return url;
  };

  const renderSectionTabs = () => {
    return (
      <div className={styles.sectionTabsRow}>
        {sortedSections.map((section, index) => {
          return (
            <Link
              className={styles.link}
              key={index}
              to={getTabLink(section.section.key)}
              onClick={() => {
                window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                dispatch(setCurrentSection(section.section.key));
              }}
              style={{
                borderBottom:
                  currentSection === section.section.key ? `2px solid ${secondary_color}` : 'none',
              }}
            >
              <Typography
                className={
                  currentSection === section.section.key
                    ? styles.selectedButtonText
                    : styles.ctaButtonText
                }
                style={{ cursor: 'pointer', color: is_white_text ? COLOR.WHITE : COLOR.BLACK }}
              >
                {getSectionTitle(section.section.key)}
              </Typography>
            </Link>
          );
        })}
      </div>
    );
  };

  const renderMobileSectionTabs = () => {
    return (
      <div className={styles.menuItemsContent}>
        {sortedSections.map((section, index) => {
          return (
            <Link
              className={styles.link}
              key={index}
              to={getTabLink(section.section.key)}
              onClick={() => {
                setShowMenu(false);
                window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                dispatch(setCurrentSection(section.section.key));
              }}
              style={{
                borderBottom:
                  currentSection === section.section.key ? `2px solid ${secondary_color}` : 'none',
              }}
            >
              <Typography
                className={
                  currentSection === section.section.key
                    ? styles.selectedButtonText
                    : styles.ctaButtonText
                }
                style={{ color: is_white_text ? COLOR.WHITE : COLOR.BLACK }}
              >
                {getSectionTitle(section.section.key)}
              </Typography>
            </Link>
          );
        })}
        <Link
          to={getTabLink('contact')}
          className={styles.link}
          onClick={(e: any) => {
            setShowMenu(false);
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
            dispatch(setCurrentSection('contact'));
          }}
          style={{
            borderBottom: currentSection === 'contact' ? `2px solid ${secondary_color}` : 'none',
          }}
        >
          <Typography
            className={
              currentSection === 'contact' ? styles.selectedButtonText : styles.ctaButtonText
            }
            style={{ color: is_white_text ? COLOR.WHITE : COLOR.BLACK }}
          >
            {fmtContact}
          </Typography>
        </Link>
      </div>
    );
  };

  const renderGridView = () => {
    return (
      <div className={styles.grid}>
        {sortedSections.map((s, index) => {
          return (
            <div className={styles.gridItem} key={index}>
              <Link
                className={styles.gridLink}
                key={index}
                to={getTabLink(s.section.key)}
                onClick={() => {
                  window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                  dispatch(setCurrentSection(s.section.key));
                }}
                style={{
                  borderBottom:
                    currentSection === s.section.key ? `2px solid ${secondary_color}` : 'none',
                }}
              >
                <Typography
                  className={
                    currentSection === s.section.key
                      ? styles.selectedButtonText
                      : styles.ctaButtonText
                  }
                  style={{ color: is_white_text ? COLOR.WHITE : COLOR.BLACK }}
                >
                  {getSectionTitle(s.section.key)}
                </Typography>
              </Link>
            </div>
          );
        })}
        <div className={styles.gridItem}>
          <Link
            to={getTabLink('contact')}
            className={styles.gridLink}
            onClick={(e: any) => {
              e.preventDefault();
              dispatch(setCurrentSection('contact'));
              const form = $('.section.contactform')[0];
              if (form) {
                form.scrollIntoView({ behavior: 'smooth', block: 'end' });
                setShowMenu(false);
              }
            }}
            style={{
              borderBottom: currentSection === 'contact' ? `2px solid ${secondary_color}` : 'none',
            }}
          >
            <Typography
              className={
                currentSection === 'contact' ? styles.selectedButtonText : styles.ctaButtonText
              }
              style={{ color: is_white_text ? COLOR.WHITE : COLOR.BLACK }}
            >
              {fmtContact}
            </Typography>
          </Link>
        </div>
      </div>
    );
  };

  if (is_grid_view) {
    return renderGridView();
  }
  if (is_mobile && showMenu) {
    return renderMobileSectionTabs();
  }
  if (is_mobile && !showMenu) {
    return null;
  }
  return (
    <div className={styles.row}>
      {sortedSections && renderSectionTabs()}
      {broker.isPremium || broker.nonMemberPortalWebsite ? (
        <Link
          className={styles.link}
          style={{
            display: 'flex',
            borderBottom: currentSection === 'contact' ? `2px solid ${secondary_color}` : 'none',
          }}
          to={getTabLink('contact')}
          onClick={(e: any) => {
            setShowMenu(false);
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
            dispatch(setCurrentSection('contact'));
          }}
        >
          <Typography
            className={
              currentSection === 'contact' ? styles.selectedButtonText : styles.ctaButtonText
            }
            style={{ color: is_white_text ? COLOR.WHITE : COLOR.BLACK }}
          >
            {fmtContact}
          </Typography>
        </Link>
      ) : null}
    </div>
  );
}
export default PageLinks;
